import { render, staticRenderFns } from "./RecordingPlay.vue?vue&type=template&id=f2835b76&scoped=true&"
import script from "./RecordingPlay.vue?vue&type=script&lang=js&"
export * from "./RecordingPlay.vue?vue&type=script&lang=js&"
import style0 from "./RecordingPlay.vue?vue&type=style&index=0&id=f2835b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2835b76",
  null
  
)

export default component.exports